import React from "react";
import { Redirect } from "react-router-dom";
import { useSelector } from "react-redux";
import { LANDING_URL } from "config";
import { withLang } from "managers/routeManager";

const GuestGuard = ({ children }) => {
  const state = useSelector((state) => state);
  const account = state.account;

  const { isLoggedIn } = account;

  if (isLoggedIn) {
    return <Redirect to={withLang(state, LANDING_URL)} />;
  }

  return <React.Fragment>{children}</React.Fragment>;
};

export default GuestGuard;
